//import liraries
import React from 'react';
import { View, StyleSheet, TouchableOpacity, Dimensions } from 'react-native';
import CText from '../../common/CText';
import CImage from '../../common/CImage';
import CView from '../../common/CView';
import CChip from './CChip';
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";


const InsurancePlanCard = ({ data, onPress, isSelected = false, isActive = false, }) => {
   
    const styles = useStyles();
    let tiType = data?.title;
    let tiPrice = data?.planPrice;
    let tiTitle = data?.title;
    let tiSubTitle = data?.subTitle;
    let isRecomended = data?.recommended;
    let tiIcon = <CImage.tiAnnualInsuranceIcon />;
    let tiStyle = { borderColor: "#7bb564" };
   
    if (tiType === "24 Hours Smart Plan") {
        tiIcon = <CImage.ti24HourRecurringIcon />;
        tiStyle = { borderColor: "#2680eb" };
    } else if (tiType === "24 Hours One-Time") {
        tiIcon = <CImage.ti24HourStandaloneIcon />;
        tiStyle = { borderColor: "#f7a710" };
    } 

    return (
        <TouchableOpacity style={[styles.cardStyle,{borderColor:isActive ? tiStyle?.borderColor : "#ccd0d5"} ]} onPress={onPress}>
            <View>{tiIcon}</View>
            <View style={styles.cardContainer}>
                <View 
                    style={{flexDirection:"row",justifyContent:"space-between",width:100}}
                >
                    <CView>
                        <CText.tripBenifitText>{tiTitle}</CText.tripBenifitText>
                        <CText.tripBenifitText>{tiSubTitle}</CText.tripBenifitText>
                    </CView>
                    <CImage.icArrowIcon />
                </View>
                <View style={{marginTop:10}} />
                <CView FR JS AC W100>
                    <CText.tripBenifitText>₹{tiPrice}</CText.tripBenifitText>
                    {isRecomended && <CChip title="RECOMMENDED" type="yellow" />}
                    {isSelected && <CChip title="SELECTED" type="red" />}
                </CView>
            </View>
        </TouchableOpacity>
    );
};

const useStyles = CreateResponsiveStyle({
    cardStyle: {
        width: 328,
        height:81,
        backgroundColor: "white",
        shadowColor: "#29000000",
        elevation: 4,
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#ccd0d5",
        borderRadius: 10,
        paddingHorizontal: 13,
        paddingVertical: 10,
        flexDirection: "row",
        justifyContent: "space-between",
        alignSelf:"center",
        alignItems:'flex-start'
    },
    cardContainer: {
        width: 200,
    },
},
{
            [DEVICE_SIZES.LG]: {},
            [DEVICE_SIZES.MD]: {},
            [DEVICE_SIZES.SM]: {},
            [DEVICE_SIZES.XS]: {
                cardStyle:{
                    width:300
                }
                
            }
        }
);

export default InsurancePlanCard;
